import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import classNames from 'classnames';
import { mobileDetect } from 'rp-gui-guide';

// on desktop iOS arrow is always down (you cannot see it when Select is opened)
const isDesktopIos = !mobileDetect.isPhone() && !mobileDetect.tablet() &&
    window.navigator.userAgent.indexOf('Mac') > -1;

class Select extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { arrowUp: false };
    }

    onSelect = (e) => {
        this.props.onSelect(e.target.value);
    };

    toggleArrow = () => {
        this.setState(({ arrowUp }) => ({ arrowUp: !arrowUp }));
    };

    downArrow = () => {
        this.setState({ arrowUp: false });
    };

    render() {
        const {
            children, value, options, wrapperClass,
        } = this.props;
        const title = children || options[value];

        const arrowClass = classNames(
            'pp-select__arrow',
            !isDesktopIos && this.state.arrowUp && 'pp-select__arrow_up'
        );

        const selectBoxState = classNames(
            this.state.arrowUp && 'ui-btn_primary pp-select__selected'
        );

        // "slt" and "sld" classes are used for automation tests
        return (
            options.length > 1 ? (
                <div className={`pp-select ui-btn ${wrapperClass} ${selectBoxState}`}>
                    { title }
                    <Svg
                        iconName="down"
                        size="Medium"
                        className={arrowClass}
                    />
                    <select
                        className="slt pp-select__input"
                        value={value}
                        onChange={this.onSelect}
                        onBlur={this.downArrow}
                        onClick={this.toggleArrow}
                    >
                        {options.map((optionText, index) =>
                            <option
                                value={index}
                                key={optionText}
                                className={value === index ? 'sld' : null}
                            >
                                {optionText}
                            </option>
                        )}
                    </select>
                </div>
            ) : (
                <div className="pp-select">{title}</div>
            )
        );
    }
}

Select.propTypes = {
    value: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.string.isRequired
    ).isRequired,
    wrapperClass: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default Select;



// WEBPACK FOOTER //
// ./src/js/shared/Select.jsx